import React, { useEffect } from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import Seo from "src/components/shared/Seo";
import server from "src/api/server";
const SingleBlog = dynamic(() => import("src/modules/Blog/Index.jsx"));

const SingleBlogPage = ({ data, appSetting = {}, footerSettings }) => {
  const router = useRouter();
  const { isFallback, locale } = router;

  const customMeta = [
    { name: "title", content: data?.singleBlogData?.page_title?.[locale] },
    {
      name: "description",
      content: data?.singleBlogData?.page_description?.[locale],
    },
  ];
  if (isFallback) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Seo
        metaData={customMeta}
        appSetting={{
          ...appSetting,
          ...footerSettings,
        }}
        pageUrl={
          typeof window !== "undefined"
            ? window.location.href
            : `${process.env.NEXT_PUBLIC_SITE_URL}/${router?.asPath}`
        }
      />
      <SingleBlog data={data} />
    </>
  );
};

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

// =================================================================================

export async function getStaticProps({ params }) {
  // Defensive: validate slug basic format (alphanumeric and dashes)
  const slug = params?.slug || "";
  if (!/^[-a-zA-Z0-9]+$/.test(slug)) {
    return { notFound: true, revalidate: 30 };
  }

  try {
    const singleBlogRes = await server.get(`/api/blogs/getBySlug/${slug}`);
    const singleBlogData = singleBlogRes?.data?.data;

    // If API returns no data => 404
    if (!singleBlogData) {
      return { notFound: true, revalidate: 30 };
    }

    const [res, footerRes] = await Promise.all([
      server.get("/api/index"),
      server.get("/api/footer"),
    ]);

    const indexData = res?.data?.data;
    const appSetting = indexData?.AppSetting || null;
    const footerSettings = footerRes?.data?.data || null;

    return {
      props: {
        data: {
          indexData: indexData || null,
          singleBlogData,
        },
        appSetting,
        footerSettings,
      },
      revalidate: 60,
    };
  } catch (e) {
    // Any error in fetching => treat as not found to avoid 500
    return { notFound: true, revalidate: 30 };
  }
}

export default SingleBlogPage;
